import { render, staticRenderFns } from "./atenatal_visit_report.vue?vue&type=template&id=bc20ef30&scoped=true&"
import script from "./atenatal_visit_report.vue?vue&type=script&lang=js&"
export * from "./atenatal_visit_report.vue?vue&type=script&lang=js&"
import style0 from "./atenatal_visit_report.vue?vue&type=style&index=0&id=bc20ef30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc20ef30",
  null
  
)

export default component.exports